var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 29.25,
    height: 29.25,
    rx: 4.625,
    fill: "#FFEEED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.375,
    y: 0.375,
    width: 29.25,
    height: 29.25,
    rx: 4.625,
    stroke: "#F96056",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 10.4706H21M12.75 8H17.25M13.5 18.7059V13.7647M16.5 18.7059V13.7647M17.625 22H12.375C11.5466 22 10.875 21.2626 10.875 20.3529L10.5326 11.3284C10.5148 10.8605 10.8554 10.4706 11.2819 10.4706H18.7181C19.1446 10.4706 19.4852 10.8605 19.4674 11.3284L19.125 20.3529C19.125 21.2626 18.4534 22 17.625 22Z",
    stroke: "#F96056",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedDelete);
export default __webpack_public_path__ + "static/media/red-delete.fd3a365a681ee1e6622fe310286bf6b9.svg";
export { ForwardRef as ReactComponent };